// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"a4c943e3","977":"18a79f08"}[chunkId] + ".chunk.js";
};